/* @flow */
import React from 'react';

// Styles
import styles from './styles.scss';

type InternalSellerNameProps = {|
    sellerName: string,
|};

export function InternalSellerName({ sellerName }: InternalSellerNameProps) {
    return (
        <div className={styles.internalByline} data-tn="internal-seller-name">
            {sellerName}
        </div>
    );
}

export default InternalSellerName;
